import tdcpMainSiteApi from "../axios/tdcpMainSiteInstance"

export const uploadFile = async (file) => {
  const formData = new FormData()
  formData.append("file", file)

  try {
    const response = await tdcpMainSiteApi.post("/api/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    // ✅ Handle API response properly
    if (response.status !== 200 || !response.data) {
      throw new Error("File upload failed")
    }

    return response.data
  } catch (error) {
    console.error("Error uploading file:", error)
    // Return more readable message if available
    const message =
      error.response?.data?.message ||
      error.message ||
      "File upload failed unexpectedly"
    throw new Error(message)
  }
}
